import * as React from 'react';
import { useNotify, useRefresh } from 'react-admin';

export default function useModerationAction() {
    const notify = useNotify();
    const refresh = useRefresh();
    const [loading, setLoading] = React.useState(false);

    const run = async ({
        id,
        missingIdMessage = 'ID manquant.',
        request,
        successMessage,
        onSuccess,
        skipRefresh = false,
    }) => {
        if (loading) return;
        if (id === undefined || id === null || id === '') {
            notify(missingIdMessage, { type: 'warning' });
            return;
        }
        setLoading(true);
        try {
            await request();
            if (successMessage) {
                notify(successMessage, { type: 'info' });
            }
            if (onSuccess) {
                onSuccess();
            }
            if (!skipRefresh) {
                refresh();
            }
        } catch (error) {
            notify(error?.message || 'Action impossible', { type: 'warning' });
        } finally {
            setLoading(false);
        }
    };

    return { loading, run };
}
